import r from"react";import e from"./divider.module.scss.js";import{classNames as i}from"@brahma/utils";var a=function(a){var o=a.type,t=void 0===o?"solid":o,m=a.className,s=void 0===m?"":m;return r.createElement("div",{className:i(e.divider,e[t],s)})};export{a as default};
//# sourceMappingURL=index.js.map
